// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fa-spin-custom,
.glyphicon-spin {
  -webkit-animation: spin 1000ms infinite linear;
  animation: spin 1000ms infinite linear;
}
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
.report-results {
  background-color: #071c35;
  padding-top: 10px;
  color: #ffffff;
}
.report-results .col-md-12 {
  padding-left: 10px;
  padding-right: 10px;
}
.report-results .vars-text {
  font-size: 14px;
  font-weight: 400;
  color: #071c35;
}
.report-results .nav-tabs {
  border-bottom: 0;
  padding-bottom: 5px;
}
.report-results .nav-tabs li > a {
  margin-right: 2px;
  border: 1px solid transparent;
  border-radius: 4px;
  color: #ffffff;
  text-decoration: none;
}
.report-results .nav-tabs li > a:hover,
.report-results .nav-tabs li > a:focus {
  color: #ffffff;
  background-color: #faa718;
  border: 1px solid #faa718;
  border-bottom-color: transparent;
}
.report-results .nav-tabs li.active > a,
.report-results .nav-tabs li.active > a:hover,
.report-results .nav-tabs li.active > a:focus {
  color: #ffffff;
  background-color: #faa718;
  border: 1px solid #faa718;
  border-bottom-color: transparent;
  cursor: default;
}
.report-results .report-results-data {
  padding: 0 10px;
}
.report-results .report-results-data .report-table {
  background-color: #445566;
}
.report-results .report-results-data .report-table thead > tr > th {
  color: #ffffff;
}
.report-results .report-results-data .report-table tr:nth-child(odd) > td {
  background-color: #d3d7da;
}
.report-results .report-results-data .report-table tr:nth-child(even) > td {
  background-color: #eaeaea;
}
.report-results .report-results-data .waiver-airport-table {
  width: 100%;
  overflow-x: scroll;
}
.report-results .report-results-data .waiver-airport-table table {
  background-color: #071c35;
  overflow-y: scroll;
}
.report-results .report-results-data .waiver-airport-table table thead {
  display: table-row;
}
.report-results .report-results-data .waiver-airport-table table thead tr > th {
  color: #ffffff;
  min-width: 90px;
}
.report-results .report-results-data .waiver-airport-table table thead tr:first-child > th {
  text-align: center;
}
.report-results .report-results-data .waiver-airport-table table thead th {
  background-color: #445566;
  border-color: #071c35;
}
.report-results .report-results-data .waiver-airport-table table thead th i.sprites {
  display: inline-block;
  vertical-align: middle;
}
.report-results .report-results-data .waiver-airport-table table thead .header {
  border-right: 2px solid #071c35;
}
.report-results .report-results-data .waiver-airport-table table thead .sub-header th:nth-child(odd) {
  border-right: 2px solid #071c35;
}
.report-results .report-results-data .waiver-airport-table table thead .sub-header th:nth-child(even) {
  border-right: 1px solid #071c35;
}
.report-results .report-results-data .waiver-airport-table table thead .empty {
  background-color: #071c35;
}
.report-results .report-results-data .waiver-airport-table table tbody {
  display: block;
  height: 300px;
}
.report-results .report-results-data .waiver-airport-table table tbody tr:nth-child(odd) > td {
  background-color: #d3d7da;
}
.report-results .report-results-data .waiver-airport-table table tbody tr:nth-child(even) > td {
  background-color: #eaeaea;
}
.report-results .report-results-data .waiver-airport-table table tbody td {
  min-width: 90px;
}
.report-results .report-results-data .waiver-airport-table table tbody td:nth-child(odd) {
  border-right: 2px solid #071c35;
}
.report-results .report-results-data .waiver-airport-table table tbody td:nth-child(even) {
  border-right: 1px solid #071c35;
}
.report-results .report-results-data .waiver-airport-table table tbody td.airport {
  font-weight: bold;
}
.report-results .report-results-data .waiver-airport-sort {
  padding: 20px 10px;
}
.report-results .report-results-data .waiver-airport-sort label {
  margin-right: 5px;
}
.report-results .report-results-data .waiver-airport-sort select {
  width: 150px;
  height: 30px;
  display: inline-block;
  background-color: #b9bfc6;
  color: white;
}
.report-results .report-results-data .waiver-airport-sort select option {
  color: black;
  text-shadow: none;
}
.report-results .report-results-data .waiver-airport-sort select -moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #b9bfc6;
}
.report-results .report-results-data li {
  cursor: pointer;
}
.report-results .results-header-container {
  padding-bottom: 5px;
}
.report-results .results-header-container .results-header {
  border-bottom: 1px solid #ffffff;
}
.report-results .results-header-container .results-header .main-title {
  color: #ffffff;
  font-size: 24px;
  padding-top: 31px;
}
.report-results .results-header-container .sub-main-title {
  color: #ffffff;
}
.report-results .results-header-container .sub-title {
  color: #ffffff;
  text-align: right;
}
.report-results .results-header-container .sub-title a {
  color: #faa718;
  text-decoration: none;
}
.report-results .results-header-container .sub-title a:hover,
.report-results .results-header-container .sub-title a:focus {
  color: #faa718;
  text-decoration: underline;
  cursor: pointer;
}
.report-results thead > tr > th {
  color: #071c35;
  font-weight: normal;
}
.report-results tbody > tr > td {
  color: #071c35;
  font-weight: normal;
}
.report-results .grand-total {
  padding: 0;
  border: 1px solid #faa718;
}
.report-results .data-point {
  color: #ffffff;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 12px;
  padding: 5px;
}
.report-results .data-point .report-table {
  background-color: #445566;
  color: #ffffff;
}
.report-results .data-point .report-table tr:nth-child(odd) > td {
  background-color: #d3d7da;
}
.report-results .data-point .report-table tr:nth-child(even) > td {
  background-color: #eaeaea;
}
.report-results .data-point .spacer {
  padding: 0;
  border-top: 0;
}
.report-results .data-point .data {
  border-top: 0;
  text-align: center;
  font-size: 12px;
  font-style: italic;
}
.report-results .data-point-bkg {
  background-color: #445566;
}
.report-results .point-title {
  text-align: center;
}
.report-results .point-title-colored {
  color: #ffffff;
  font-weight: bold;
}
.report-results .negative-value {
  color: #c02323;
}
.report-results .positive-value {
  color: #7dd63b;
  font-size: 24px;
}
.report-results .data-total {
  font-weight: bold;
}
.report-results .data-base-simple {
  text-align: center;
}
.report-results .data-base {
  text-align: center;
  font-weight: bold;
}
.report-results .data-base-highlight {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
}
.report-results .data-base-sub-1 {
  text-align: center;
  font-size: 12px;
  font-style: italic;
}
.report-results .data-base-sub-2 {
  text-align: center;
  font-weight: bold;
  font-size: 12px;
}
.report-results .data-base-sep {
  padding: 5px 0;
}
.report-results .data-base-total-sep {
  margin: 5px 0;
  border: 1px solid #071c35;
}
.report-results .data-base-total-label {
  text-align: center;
  font-weight: bold;
}
.report-results .data-base-total-value {
  text-align: center;
  font-weight: bold;
  font-size: 24px;
}
.report-results .data-base-sub-note {
  font-size: 12px;
}
.report-results .summary-box {
  border: 3px solid #414141;
  height: 120px;
}
.report-results .summary-box .box-label {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}
.report-results .summary-box .box-value {
  font-size: 48px;
  font-weight: bold;
  text-align: center;
}
.report-results .double-summary-box {
  border: 3px solid #414141;
  height: 260px;
}
.report-results .double-summary-box .box-label {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}
.report-results .double-summary-box .box-value {
  font-size: 24px;
  font-weight: bold;
  text-align: left;
  white-space: nowrap;
}
.report-results .summary-box-tooltip .tooltip-inner {
  background-color: #414141;
}
.report-results .summary-box-tooltip .tooltip-arrow {
  border-top-color: #414141;
}
.report-results .chart-container {
  padding-top: 10px;
}
.report-results .chart-container .chart-title {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  padding-bottom: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/modules/utility.less","webpack://./src/styles/modules/report-results.less"],"names":[],"mappings":"AAiGA;;EAEE,8CAAA;EACA,sCAAA;AChGF;ADkGA;EACE;IACE,+BAAA;IACA,uBAAA;EChGF;EDkGA;IACE,iCAAA;IACA,yBAAA;EChGF;AACF;ADkGA;EACE;IACE,+BAAA;IACA,uBAAA;EChGF;EDkGA;IACE,iCAAA;IACA,yBAAA;EChGF;AACF;AAdA;EACE,yBAAA;EACA,iBAAA;EACA,cAAA;AAgBF;AAnBA;EAMI,kBAAA;EACA,mBAAA;AAgBJ;AAvBA;EAWI,eAAA;EACA,gBAAA;EACA,cAAA;AAeJ;AA5BA;EAiBI,gBAAA;EACA,mBAAA;AAcJ;AAhCA;EAqBM,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;AAcN;AAvCA;;EA8BM,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,gCAAA;AAaN;AA9CA;;;EAuCM,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,gCAAA;EACA,eAAA;AAYN;AAvDA;EAgDI,eAAA;AAUJ;AA1DA;EAmDM,yBAAA;AAUN;AA7DA;EAsDQ,cAAA;AAUR;AAhEA;EA0DQ,yBAAA;AASR;AAnEA;EA8DQ,yBAAA;AAQR;AAtEA;EAmEM,WAAA;EACA,kBAAA;AAMN;AA1EA;EAuEQ,yBAAA;EACA,kBAAA;AAMR;AA9EA;EA2EU,kBAAA;AAMV;AAjFA;EA8EY,cAAA;EACA,eAAA;AAMZ;AArFA;EAmFY,kBAAA;AAKZ;AAxFA;EAuFY,yBAAA;EACA,qBAAA;AAIZ;AA5FA;EA2Fc,qBAAA;EACA,sBAAA;AAId;AAhGA;EAiGY,+BAAA;AAEZ;AAnGA;EAsGc,+BAAA;AAAd;AAtGA;EA0Gc,+BAAA;AADd;AAzGA;EA+GY,yBAAA;AAHZ;AA5GA;EAoHU,cAAA;EACA,aAAA;AALV;AAhHA;EAwHY,yBAAA;AALZ;AAnHA;EA4HY,yBAAA;AANZ;AAtHA;EAgIY,eAAA;AAPZ;AAzHA;EAoIY,+BAAA;AARZ;AA5HA;EAwIY,+BAAA;AATZ;AA/HA;EA4IY,iBAAA;AAVZ;AAlIA;EAmJM,kBAAA;AAdN;AArIA;EAsJQ,iBAAA;AAdR;AAxIA;EA0JQ,YAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,YAAA;AAfR;AA/IA;EAgKU,YAAA;EACA,iBAAA;AAdV;AAnJA;EAqKU,kBAAA;EACA,0BAAA;AAfV;AAvJA;EA4KM,eAAA;AAlBN;AA1JA;EAiLI,mBAAA;AApBJ;AA7JA;EAoLM,gCAAA;AApBN;AAhKA;EAuLQ,cAAA;EACA,eAAA;EACA,iBAAA;AApBR;AArKA;EA8LM,cAAA;AAtBN;AAxKA;EAkMM,cAAA;EACA,iBAAA;AAvBN;AA5KA;EDuBI,cAAA;EACA,qBAAA;ACwJJ;AAhLA;;ED4BI,cAAA;EACA,0BAAA;EACA,eAAA;ACwJJ;AAtLA;EAyMI,cAAA;EACA,mBAAA;AAhBJ;AA1LA;EA8MI,cAAA;EACA,mBAAA;AAjBJ;AA9LA;EAmNI,UAAA;EACA,yBAAA;AAlBJ;AAlMA;EAwNI,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAnBJ;AAzMA;EA+NM,yBAAA;EACA,cAAA;AAnBN;AA7MA;EAmOQ,yBAAA;AAnBR;AAhNA;EAuOQ,yBAAA;AApBR;AAnNA;EA4OM,UAAA;EACA,aAAA;AAtBN;AAvNA;EAiPM,aAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AAvBN;AA7NA;EAyPI,yBAAA;AAzBJ;AAhOA;EA6PI,kBAAA;AA1BJ;AAnOA;EAiQI,cAAA;EACA,iBAAA;AA3BJ;AAvOA;EAsQI,cAAA;AA5BJ;AA1OA;EA0QI,cAAA;EACA,eAAA;AA7BJ;AA9OA;EA+QI,iBAAA;AA9BJ;AAjPA;EAmRI,kBAAA;AA/BJ;AApPA;EAuRI,kBAAA;EACA,iBAAA;AAhCJ;AAxPA;EA4RI,kBAAA;EACA,iBAAA;EACA,eAAA;AAjCJ;AA7PA;EAkSI,kBAAA;EACA,eAAA;EACA,kBAAA;AAlCJ;AAlQA;EAwSI,kBAAA;EACA,iBAAA;EACA,eAAA;AAnCJ;AAvQA;EA8SI,cAAA;AApCJ;AA1QA;EAkTI,aAAA;EACA,yBAAA;AArCJ;AA9QA;EAuTI,kBAAA;EACA,iBAAA;AAtCJ;AAlRA;EA4TI,kBAAA;EACA,iBAAA;EACA,eAAA;AAvCJ;AAvRA;EAkUI,eAAA;AAxCJ;AA1RA;EAsUI,yBAAA;EACA,aAAA;AAzCJ;AA9RA;EA0UM,eAAA;EACA,iBAAA;EACA,kBAAA;AAzCN;AAnSA;EAgVM,eAAA;EACA,iBAAA;EACA,kBAAA;AA1CN;AAxSA;EAuVI,yBAAA;EACA,aAAA;AA5CJ;AA5SA;EA2VM,eAAA;EACA,iBAAA;EACA,kBAAA;AA5CN;AAjTA;EAiWM,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AA7CN;AAvTA;EA0WM,yBAAA;AAhDN;AA1TA;EA6WM,yBAAA;AAhDN;AA7TA;EAkXI,iBAAA;AAlDJ;AAhUA;EAqXM,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAlDN","sourcesContent":["@import 'colors';\n\n@link-text-color: @ivory;\n@link-hover-color: @orange;\n\n@blue-link-text-color: @blue2;\n@blue-link-hover-color: @blue4;\n\n@border-radius: 3px;\n@large-border-radius: 10px;\n@z-index-high: 999;\n@z-index-modal: 1050;\n@issue-padding: 10px;\n@input-height: 2.5rem;\n@button-width: 125px;\n@button-height: 30px;\n@time-picker-input-width: 3.125rem;\n\n.link(@text-color: @link-text-color, @hover-color: @link-hover-color) {\n  a {\n    color: @text-color;\n    text-decoration: none;\n  }\n  a:hover,\n  a:focus {\n    color: @hover-color;\n    text-decoration: none;\n    cursor: pointer;\n  }\n}\n\n.link-underline(@text-color: @blue-link-text-color, @hover-color: @blue-link-hover-color, @decoration: underline) {\n  a {\n    color: @text-color;\n    text-decoration: @decoration;\n  }\n  a:hover,\n  a:focus {\n    color: @hover-color;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n}\n\n.horizontal-list(@padding: 15px) {\n  ul,\n  ol {\n    display: block;\n    margin-left: 0;\n  }\n  li {\n    display: inline;\n    list-style-type: none;\n    padding: @padding;\n\n    .link();\n  }\n  /* not ie8 compat.\n  li + li::before {\n    content: \" | \";\n  }\n  */\n}\n\n.spinner(@top: 0, @right: 0, @bottom: 0, @left: 0) {\n  position: fixed;\n  top: @top;\n  right: @right;\n  bottom: @bottom;\n  left: @left;\n  z-index: 1100;\n  background-color: @choc;\n  opacity: 0.7;\n  filter: alpha(opacity=70);\n  display: none; /* do not show by default */\n\n  .image {\n    background: url('@{asset-base-url}/images/spinner.gif') no-repeat;\n    background-size: 36px 36px;\n    width: 36px;\n    height: 36px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin-left: -18px; /* -1 * image width / 2 */\n    margin-top: -18px; /* -1 * image height / 2 */\n    border: none;\n  }\n\n  .processing-msg {\n    color: @link-text-color;\n    text-align: center;\n    vertical-align: middle;\n    line-height: 60;\n  }\n}\n\n.fa-spin-custom,\n.glyphicon-spin {\n  -webkit-animation: spin 1000ms infinite linear;\n  animation: spin 1000ms infinite linear;\n}\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n","@import 'colors';\n@import './utility.less';\n\n@report-results-bg-color: @blue1;\n@report-results-text-color: @white;\n@report-results-leg-sep-color: @gray4;\n@report-results-selected-color: @gray3;\n@report-results-critical-color: @red;\n@report-results-link-color: @orange;\n\n.report-results {\n  background-color: @report-results-bg-color;\n  padding-top: 10px;\n  color: @white;\n\n  .col-md-12 {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n\n  .vars-text {\n    font-size: 14px;\n    font-weight: 400;\n    color: @choc;\n  }\n\n  .nav-tabs {\n    border-bottom: 0;\n    padding-bottom: 5px;\n\n    li > a {\n      margin-right: 2px;\n      border: 1px solid transparent;\n      border-radius: 4px;\n      color: @white;\n      text-decoration: none;\n    }\n\n    li > a:hover,\n    li > a:focus {\n      color: @white;\n      background-color: @orange;\n      border: 1px solid @orange;\n      border-bottom-color: transparent;\n    }\n\n    li.active > a,\n    li.active > a:hover,\n    li.active > a:focus {\n      color: @white;\n      background-color: @orange;\n      border: 1px solid @orange;\n      border-bottom-color: transparent;\n      cursor: default;\n    }\n  }\n\n  .report-results-data {\n    padding: 0 10px;\n\n    .report-table {\n      background-color: @tripB2;\n\n      thead > tr > th {\n        color: @white;\n      }\n\n      tr:nth-child(odd) > td {\n        background-color: @row1;\n      }\n\n      tr:nth-child(even) > td {\n        background-color: @row2;\n      }\n    }\n\n    .waiver-airport-table {\n      width: 100%;\n      overflow-x: scroll;\n\n      table {\n        background-color: @blue1;\n        overflow-y: scroll;\n\n        thead {\n          display: table-row;\n\n          tr > th > {\n            color: @white;\n            min-width: 90px;\n          }\n\n          tr:first-child > th {\n            text-align: center;\n          }\n\n          th {\n            background-color: @tripB2;\n            border-color: @blue1;\n\n            i.sprites {\n              display: inline-block;\n              vertical-align: middle;\n            }\n          }\n\n          .header {\n            border-right: 2px solid @blue1;\n          }\n\n          .sub-header {\n            th:nth-child(odd) {\n              border-right: 2px solid @blue1;\n            }\n\n            th:nth-child(even) {\n              border-right: 1px solid @blue1;\n            }\n          }\n\n          .empty {\n            background-color: @blue1;\n          }\n        }\n\n        tbody {\n          display: block;\n          height: 300px;\n\n          tr:nth-child(odd) > td {\n            background-color: @row1;\n          }\n\n          tr:nth-child(even) > td {\n            background-color: @row2;\n          }\n\n          td {\n            min-width: 90px;\n          }\n\n          td:nth-child(odd) {\n            border-right: 2px solid @blue1;\n          }\n\n          td:nth-child(even) {\n            border-right: 1px solid @blue1;\n          }\n\n          td.airport {\n            font-weight: bold;\n          }\n        }\n      }\n    }\n\n    .waiver-airport-sort {\n      padding: 20px 10px;\n\n      label {\n        margin-right: 5px;\n      }\n\n      select {\n        width: 150px;\n        height: 30px;\n        display: inline-block;\n        background-color: #b9bfc6;\n        color: white;\n        option {\n          color: black;\n          text-shadow: none;\n        }\n\n        -moz-focusring {\n          color: transparent;\n          text-shadow: 0 0 0 #b9bfc6;\n        }\n      }\n    }\n\n    li {\n      cursor: pointer;\n    }\n  }\n\n  .results-header-container {\n    padding-bottom: 5px;\n\n    .results-header {\n      border-bottom: 1px solid @white;\n\n      .main-title {\n        color: @white;\n        font-size: 24px;\n        padding-top: 31px;\n      }\n    }\n\n    .sub-main-title {\n      color: @white;\n    }\n\n    .sub-title {\n      color: @white;\n      text-align: right;\n      .link-underline(@orange, @orange, none);\n    }\n  }\n\n  thead > tr > th {\n    color: @blue1;\n    font-weight: normal;\n  }\n\n  tbody > tr > td {\n    color: @blue1;\n    font-weight: normal;\n  }\n\n  .grand-total {\n    padding: 0;\n    border: 1px solid @orange;\n  }\n\n  .data-point {\n    color: @report-results-text-color;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    margin-right: 12px;\n    padding: 5px;\n\n    .report-table {\n      background-color: @tripB2;\n      color: @white;\n\n      tr:nth-child(odd) > td {\n        background-color: @row1;\n      }\n\n      tr:nth-child(even) > td {\n        background-color: @row2;\n      }\n    }\n\n    .spacer {\n      padding: 0;\n      border-top: 0;\n    }\n\n    .data {\n      border-top: 0;\n      text-align: center;\n      font-size: 12px;\n      font-style: italic;\n    }\n  }\n\n  .data-point-bkg {\n    background-color: @tripB2;\n  }\n\n  .point-title {\n    text-align: center;\n  }\n\n  .point-title-colored {\n    color: @white;\n    font-weight: bold;\n  }\n\n  .negative-value {\n    color: @red;\n  }\n\n  .positive-value {\n    color: @onTimeGreen;\n    font-size: 24px;\n  }\n\n  .data-total {\n    font-weight: bold;\n  }\n\n  .data-base-simple {\n    text-align: center;\n  }\n\n  .data-base {\n    text-align: center;\n    font-weight: bold;\n  }\n\n  .data-base-highlight {\n    text-align: center;\n    font-weight: bold;\n    font-size: 16px;\n  }\n\n  .data-base-sub-1 {\n    text-align: center;\n    font-size: 12px;\n    font-style: italic;\n  }\n\n  .data-base-sub-2 {\n    text-align: center;\n    font-weight: bold;\n    font-size: 12px;\n  }\n\n  .data-base-sep {\n    padding: 5px 0;\n  }\n\n  .data-base-total-sep {\n    margin: 5px 0;\n    border: 1px solid @blue1;\n  }\n\n  .data-base-total-label {\n    text-align: center;\n    font-weight: bold;\n  }\n\n  .data-base-total-value {\n    text-align: center;\n    font-weight: bold;\n    font-size: 24px;\n  }\n\n  .data-base-sub-note {\n    font-size: 12px;\n  }\n\n  .summary-box {\n    border: 3px solid @gray1;\n    height: 120px;\n\n    .box-label {\n      font-size: 14px;\n      font-weight: bold;\n      text-align: center;\n    }\n\n    .box-value {\n      font-size: 48px;\n      font-weight: bold;\n      text-align: center;\n    }\n  }\n\n  .double-summary-box {\n    border: 3px solid @gray1;\n    height: 260px;\n\n    .box-label {\n      font-size: 14px;\n      font-weight: bold;\n      text-align: center;\n    }\n\n    .box-value {\n      font-size: 24px;\n      font-weight: bold;\n      text-align: left;\n      white-space: nowrap;\n    }\n  }\n\n  .summary-box-tooltip {\n    .tooltip-inner {\n      background-color: @gray1;\n    }\n    .tooltip-arrow {\n      border-top-color: @gray1;\n    }\n  }\n\n  .chart-container {\n    padding-top: 10px;\n\n    .chart-title {\n      font-size: 14px;\n      font-weight: bold;\n      text-align: center;\n      padding-bottom: 5px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
